import { ExperimentsExtension } from '@wix/premium-fed-sdk-kit/@extensions';
export const StudioExperimentsExtension = ExperimentsExtension({
  scope: ['premium-purchase-plan', 'premium-package-pickers']
});

/**
 * Creates a StudioExperimentsExtension with pre-conducted experiments.
 * Use in Storybook/tests to enable specific experiments without a live scope fetch.
 */
export const createStudioExperimentsExtension = experiments => ExperimentsExtension(experiments ? {
  experiments
} : {
  scope: ['premium-purchase-plan', 'premium-package-pickers']
});
//# sourceMappingURL=studio-experiments.extension.js.map